import IsServeMode from "./IsServeMode";

export default function UseWebservice() {
    if(!IsServeMode()) {
        return true;
    }

    if(window.location.search.indexOf("useWebserviceCall=1") >= 0) {
        return true;
    }

    return false;
}
